import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-slate-200" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#025B57] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#0B2545]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#0A7D79]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE NURSING{' '}
            <span className="text-[#0A7D79]" data-id="element-25" data-mp="1jilsvgh7ee0a">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1enxzp4b98vfd">
            The six main volumes give you visual training material for every core nursing teaching area. And the
            five bonuses add practical tools to help you drill vital signs and nursing essentials, script your skills
            demonstrations, run skills-lab and simulation drills, practice dosage calculations, and assess
            students with clear competency checklists, rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2ogzhxwouq4lt">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-slate-200 rounded-2xl p-8 shadow-sm shadow-[#0B2545]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="1qt8nc4h3amuh" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#0B2545] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3h5myjeyno5t1">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#E4EEF4] border border-[#B8C4CE] rounded-full flex items-center justify-center text-[#0A7D79] mb-4" data-id="element-30" data-mp="1h58934j2xtdn">
                <Gift size={24} data-id="element-31" data-mp="1q323ub174eyp" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#0B2545]" data-id="element-32" data-mp="1q1qyw7w0l160">{bonus.title}</h3>
              <p className="text-[#025B57] text-sm font-semibold mb-4 border-l-4 border-[#0A7D79] pl-4" data-id="element-33" data-mp="ycxbnq772nmx">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="175r4yrjh7njs">
                  <span className="text-slate-500" data-id="element-35" data-mp="12eiwbxpz067o">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="12cehwlug3ot5">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-[#025B57] uppercase tracking-wide" data-id="element-37" data-mp="ao4n4eswji2c">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5awimn0bbwec">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#0B2545] font-semibold text-sm mb-3" data-id="element-39" data-mp="3rpfuabxwkxh4">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="ja5ootut1a4l">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="eajcmnqppzxd">
                        <CheckCircle2 size={16} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-42" data-mp="ecma1su72vc4" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2u4a4nhlqkbrr">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#0B2545] font-semibold text-sm mb-3" data-id="element-44" data-mp="3agez7lvzow62">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="35jesr9v89ref">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30klcj9ok3mak">
                        <CheckCircle2 size={16} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-47" data-mp="21wn992xgwh6" />
                        <div data-id="element-48" data-mp="3t7eetwhlgtmo">
                          <span className="block text-[#0B2545] font-bold text-sm" data-id="element-49" data-mp="3t8h7o9yh9658">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3o79yc6gorywg">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#0B2545] font-semibold text-sm mb-3" data-id="element-51" data-mp="27ttnqx9tlzx9">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="sbna5znp3k70">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#0B2545] font-semibold text-sm bg-[#E4EEF4] border border-[#D0DEE8] rounded-lg px-3 py-2" data-id="element-53" data-mp="x9p1t8z6sru3">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1g1hn0h80l8r9">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="1kzjfttv8smfx">
                {bonus.system && <div data-id="element-56" data-mp="3hu5retwea28m">
                    <p className="text-[#0B2545] font-semibold text-sm mb-2" data-id="element-57" data-mp="3hupcukl978re">{bonus.systemLabel}</p>
                    <p className="text-[#0B2545] font-bold text-xs sm:text-sm tracking-wide bg-[#E4EEF4] border-l-4 border-[#0A7D79] rounded-lg px-3 py-2" data-id="element-58" data-mp="3mts6l8vs9sk2">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#F3F7FA] border border-[#D0DEE8] border-l-4 border-l-[#0B2545] rounded-xl p-4" data-id="element-59" data-mp="3on2y5k19545v">
                    <span className="text-[#0B2545] font-bold block mb-1" data-id="element-60" data-mp="1kgdmw2uq9bx">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="1i3l5ozgwgkm">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-slate-200" data-id="element-62" data-mp="b980wqwyw5gi">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#0B2545] font-extrabold text-base tracking-wide' : 'text-[#0B2545] font-semibold text-sm italic'} data-id="element-63" data-mp="6byb3a5o1rs5" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}